export function capitalizeFirstLetterOfWords(str) {
    return str.replace(/\b\w/g, function(char) {
        return char.toUpperCase();
    });
}



export const formatDate = (inputDate) => {
  // Parse the input date string
  const parsedDate = new Date(inputDate);

  // Format the date to 'DD/MM/YYYY' format
  const formattedDate = parsedDate.toLocaleDateString('en-GB');

  // Format the time to 'HH:MM AM/PM' format
  const formattedTime = parsedDate.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true,
  });

  // Combine date and time
  return `${formattedDate} ${formattedTime}`;
};

// export const formatDate=(inputDate)=>{
//   // Parse the input date string
//   const parsedDate = new Date(inputDate);

//   // Format the date to the desired output format
//   const formattedDate = parsedDate.toLocaleDateString('en-GB');

//   return formattedDate;
// }


export const convertDateFormat = (inputDate) => {
  // Convert the input date string to a Date object
  const date = new Date(inputDate);

  // Get the year, month, and day from the Date object
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based, add 1
  const day = String(date.getDate()).padStart(2, '0');

  // Format the date as YYYY-MM-DD
  return `${year}-${month}-${day}`;
};



export function getCurrentMonth() {
  const months = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
  ];
  
  const currentMonthIndex = new Date().getMonth();
  return months[currentMonthIndex];
}




export const  formatAmount = (amount) => {
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};